<template>
  <div>
    <el-dialog
      title="选择圈子"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.content"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="搜索ID、圈子名称"
            ></b-form-input>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="search()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="app-list-sort">
            <b-dropdown>
              <template v-slot:button-content>
                <sort-icon />
              </template>
              <b-dropdown-item
                v-for="(item, index) in sortList"
                :key="index"
                @click="listSort(item)"
              >
                <span class="pull-left" v-if="pageParams.sortBy == item.value">
                  <i
                    v-if="pageParams.order == 'desc'"
                    class="bx bx-down-arrow-alt font-size-18 pull-left"
                  ></i>
                  <i
                    v-if="pageParams.order == 'asc'"
                    class="bx bx-up-arrow-alt font-size-18"
                  ></i>
                </span>
                <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                  item.text
                }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="table-responsive-main-list" style="overflow: hidden">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px"></th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">圈子名称</th>
                  <th scope="col">封面</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建日期</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="media-dialog-radio">
                    <el-radio v-model="showState" :label="item.id"></el-radio>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-200px white-inherit">{{ item.name }}</td>
                  <td>
                    <img
                      v-if="item.cover"
                      class="w-3-rem"
                      :src="`${item.cover}`"
                      alt
                    />
                    <img
                      v-if="!item.cover"
                      class="w-3-rem"
                      src="@/assets/images/default_cover_1_1.png"
                      alt=""
                    />
                  </td>
                  <td>
                    <span v-if="item.showDisabled == 0">显示</span>
                    <span v-else>隐藏</span>
                  </td>
                  <td>{{ item.createdAt }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-list-loading ref="loading"></app-list-loading>
        </div>

        <pagination
          :total="pageTotal"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          :pageSizes="[10, 20, 30]"
          ref="page"
          @pageCallback="pageCallback"
        ></pagination>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
// import pagination from "@/components/pagination/pagination.vue";
import pagination from "@/components/pagination/pagination.vue";
import momentFocus from "../../../../server/api/momentFocus";
import groupApi from "@/server/api/group.js";

export default {
  components: { pagination },

  data() {
    return {
      pageTotal: 0,
      pageParams: {
        page: 1,
        pageSize: 10,
        sortBy: "",
        order: "",
        content: "",
      },
      // pageParams: {
      //   page: 1,
      //   pageSize: 10,
      //   sortBy: "",
      //   order: "",
      //   content: "",
      // },
      tagId: "",
      currentTag: "",
      items: [],
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      show: false,
      contentTypeList: [
        {
          id: "article",
          name: "文章",
        },
        {
          id: "video",
          name: "视频",
        },
        {
          id: "stream",
          name: "直播",
        },
        {
          id: "subject",
          name: "专题",
        },
      ],
      sortList: [
        { text: "ID", value: "id" },
        { text: "发布日期", value: "publishTime" },
      ],
      searchTagName: "",
      searchTagList: [],
      showState: "",
    };
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  watch: {
    choiceListIds: function () {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {},

  methods: {
    showModel(userId) {
      let that = this;
      if (userId) {
        this.showState = userId;
      }
      setTimeout(function (argument) {
        that.resetParams();
      }, 0);

      // this.getList();
      this.show = true;
    },

    handleClose() {
      this.show = false;
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      // if (obj.code === "pageSize") {
      //   if (obj.ps == 100) {
      //     this.pageParams.pageSize = 100;
      //     this.getList();
      //   } else if (obj.ps == 50) {
      //     this.pageParams.pageSize = 50;
      //     this.getList();
      //   } else {
      //     this.pageParams.pageSize = 30;
      //     this.getList();
      //   }
      // }
      // if (obj.code === "page") {
      //   //更改页码
      //   this.pageParams.page = obj.page;
      //   this.getList();
      // }
    },

    //获取列表数据
    getList() {
      this.items = [];

      this.$refs.loading.show();
      let params = this.utils.getQuery(this.pageParams);
      groupApi.list(params).then((resp) => {
        if (resp.code == 0) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(resp.data.items);
          }
          if (resp.data) {
            let ids = [];
            this.choiceListIds = [];
            resp.data.items.map((item) => {
              if (!item.isRelation) {
                ids.push(item.id);
              }
            });
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;

            // let pages = {
            //   page: resp.data.page, //第几页
            //   pageSize: resp.data.pageSize, //每页多少条
            //   total: resp.data.total, //全部有多少条数据
            //   totalPages: resp.data.totalPages, //全部有几页
            // };
          }
        }
      });
    },

    submitCreate() {
      let current = {
        code: "circle",
        item: {},
      };
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id == this.showState) {
          current.item = this.items[i];
        }
      }
      this.handleClose();
      this.$emit("pageCallback", current);
      // let data = this.choiceListIds;
      // let addData = [];
      // data.map(val => {
      //   addData.push({
      //     relationId: val,
      //     relationType: 'circle',
      //     sourceType: 'highlight'
      //   });
      // });

      // momentFocus.circle.add(addData).then((resp) => {
      //   if (resp.code == 0) {
      //     Vue.swal({
      //       icon: "success",
      //       title: "添加成功！",
      //       showConfirmButton: false,
      //       timer: 1000,
      //     });
      //     this.handleClose();
      //     this.$emit("getList");
      //   }
      // });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.tagId = "";
      this.pageParams.content = "";
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.getList();
    },

    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "asc"; //默认正序
      }
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },
  },
};
</script>
<style></style>
